<template>
  <app-modal-prompt
    :value="value"
    :loading="loading" 
    @input="e => $emit('input', e)" 
    @confirm="updateCSVOneLineValues"
    @cancel="$emit('cancel')"
  >
    <template #title>
      {{ title }}
    </template>
      <app-modal-container fluid>
        <app-modal-row v-if="$slots.top_actions">
          <app-modal-col cols="12">
            <slot name="top_actions"></slot>
          </app-modal-col>
        </app-modal-row>
        <app-modal-row>
          <app-modal-col cols="6">
            <app-text-field
              class="mr-2"
              v-model="csv_one_line_field_values['kind']['in_invoice']"
              label="Tipo de factura de Proveedor"
            />
          </app-modal-col>
          <app-modal-col cols="6">
            <app-text-field
              kind="text"
              class="ml-2"
              v-model="csv_one_line_field_values['kind']['out_invoice']"
              label="Tipo de factura de Cliente"
            />
          </app-modal-col>
        </app-modal-row>
      </app-modal-container>
  </app-modal-prompt>
</template>

<script>
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  name: "CsvFieldsValues",
  components: {
    AppTextField,
    AppModalCol,
    AppModalContainer,
    AppModalRow,
    AppModalPrompt,
  },
  props:{
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    cdb_id: {
      type: String,
      default: null,
    },
    is_cdb_required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapFields("config", {
      csv_one_line_field_values: "csv_one_line_field_values",
    }),
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      getFieldValuesCsvOneLine: "config/getFieldValuesCsvOneLine",
      setFieldValuesCsvOneLine: "config/setFieldValuesCsvOneLine",
      copyCsvValuesOneLine: "connector/copyCsvValuesOneLine",
    }),
    updateCSVOneLineValues() {
      this.loading = true
      if (!(this.is_cdb_required && !this.cdb_id)){
        this.setFieldValuesCsvOneLine(this.cdb_id)
          .then(() => {
            this.$emit("success");
          })
          .catch((err) => {
            this.$emit("error")
            console.error(err);
          })
          .finally(() => {
            this.$emit("cancel");
            this.loading = false
          })
      }
    },
  },
  mounted() {
    this.getFieldValuesCsvOneLine(this.cdb_id);
  },
};
</script>

<style lang="scss" scoped>
    .text-color {
        color: var(--v-primary-base);
    }
</style>
